export const homeHero = {
    init: () => {
        const $ = jQuery;

        const animationWrappers = $('#home-hero .animation');

        const runAnimation = (iteration, faceWrappers, lines, delay) => {
            const lDelay = faceWrappers.length * delay;

            faceWrappers.sort(() => Math.random() - 0.5);

            faceWrappers.each((index, wrapper) => {
                const face = $(wrapper).find('.' + iteration);
                let iDelay = delay * index;

                setTimeout( () => {
                    face.toggleClass('animate');

                }, iDelay);
            });

            setTimeout( () => {
                lines.toggleClass('animate');
            }, lDelay);

            setTimeout( () => {
                reverseAnimation(iteration, faceWrappers, lines, delay);
            }, lDelay + (delay * 3));
        }

        const reverseAnimation = (iteration, faceWrappers, lines, delay) => {
            const lDelay = faceWrappers.length * delay;

            faceWrappers.sort(() => Math.random() - 0.5);

            lines.toggleClass('animate');

            faceWrappers.each((index, wrapper) => {
                const face = $(wrapper).find('.' + iteration);
                let iDelay = delay * (index + 1);

                setTimeout( () => {
                    face.toggleClass('animate');

                }, iDelay);
            });

            setTimeout( () => {
                iteration = iteration === 'first' ? 'second' : 'first';
                
                runAnimation(iteration, faceWrappers, lines, delay);
            }, lDelay + (delay * 3));
        }

        animationWrappers.each((index, wrapper) => {
            const faceWrappers = $(wrapper).find('.faces-wrapper');
            const lines = $(wrapper).find('.animation-lines');
            const delay = 450;
            let iteration = 'first';

            runAnimation(iteration, faceWrappers, lines, delay);
        });


        // let lines = $('#home-hero .animation-lines');
        // let faces = null;
        // let after = 8;

        // if ( $(window).innerWidth() < 768 ) {
        //     after = 3;
        //     mobileFaces = mobileFaces.sort(() => Math.random() - 0.5);
        //     otherFaces = otherFaces.sort(() => Math.random() - 0.5);

        //     faces = [...mobileFaces, ...otherFaces];
        // } else {
        //     faces = [...mobileFaces, ...otherFaces];

        //     faces = faces.sort(() => Math.random() - 0.5);
        // }

        // let delay = 0;

        // for (let i = 0; i < faces.length; i++) {
        //     setTimeout( () => {
        //         $(faces[i]).addClass('animate');
        //     }, delay );

        //     delay += 450;

        //     if (i === after) {
        //         setTimeout( () => {
        //             $(lines).addClass('animate');
        //         }, delay );
        //     }
        // }
    }
}